/**
 * The MIT License (MIT)
 * Copyright (c) 2017-present Dmitry Soshnikov <dmitry.soshnikov@gmail.com>
 */

'use strict';

module.exports = require('./dist/regexp-tree');


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/regexp-tree/index.js
// module id = 1043
// module chunks = 0